import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, Modal } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'
import * as XLSX from 'xlsx'

import { toast } from 'react-toastify'
import {
  AlumniAppList,
  AlumniApprovalPendingList,
  AlumniApproveReject,
  GetFeeMaster,
  IMG_BASE_URL,
  IMG_BASE_URL3,
  RegFormAppPendingList,
  RegFormApprovedList,
  RegFormApproveReject,
  StudentFeeConcession,
} from '../../../AllAPI/AdminAPI'

const AlumniApprovedList = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [confirmChecked, setConfirmChecked] = useState(false)

  const [approveLoading, setApproveLoading] = useState(false)
  const [rejectLoading, setRejectLoading] = useState(false)
  const [rejectReason, setRejectReason] = useState('')
  const [rejectModalOpen, setRejectModalOpen] = useState(false)

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchAlumniApprovedList()
  }, [])

  const fetchAlumniApprovedList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${AlumniAppList}`)

      const formatted = res.data.map((item, index) => ({
        key: item.id,
        index: index + 1,
        full_name: `${item.f_name} ${item.m_name} ${item.l_name}`,
        email: item.email || '-',
        date_of_birth: item.date_of_birth || '-',
        mobile: item.mobile || '-',
        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false)
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.mobile ?? '').toString().includes(search) ||
      (item.email ?? '').toLowerCase().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'Mobile No.', dataIndex: 'mobile' },
    { title: 'Email Id', dataIndex: 'email' },
    { title: 'Birth Date', dataIndex: 'date_of_birth' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]

  const handleCancel = () => {
    setViewModalOpen(false)

    fetchAlumniApprovedList()
  }

  // =======CSS==========
  const labelCss = {
    fontWeight: '600',
  }
  const titleText = {
    fontWeight: '600',
    fontSize: '16px',
    color: '#235784',
  }

  const exportToExcel = () => {
    const excelData = filteredData.map((item) => {
      const student = { ...item.full_data }

      // Flatten nested objects
      student.admin = student.admin?.username || ''
      student.documents = JSON.stringify(student.documents || {})

      return student
    })

    const worksheet = XLSX.utils.json_to_sheet(excelData)
    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Alumni Approved')

    XLSX.writeFile(workbook, 'Alumni_Approved_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Alumni Approved List</h2>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ---------- VIEW MODAL ---------- */}

      <Modal
        title={null}
        open={viewModalOpen}
        onCancel={() => {
          setViewModalOpen(false)
          handleCancel()
        }}
        footer={null}
        width={980}
      >
        {selectedRecord && (
          <div className="py-4 px-md-4">
            {/* HEADER */}
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Alumni Details
            </h3>

            <div
              className="border rounded shadow p-2 p-md-4"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              {/* ========= PERSONAL INFORMATION ========== */}
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-12 col-md-3">
                    <img
                      src={`${IMG_BASE_URL3}${selectedRecord.profile_img}`}
                      alt="Picture"
                      className="rounded-circle text-center img-fluid rounded border"
                      style={{
                        width: '160px',
                        height: '160px',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-9">
                    <div className="row">
                      <div className="col-md-12 py-1">
                        <span style={labelCss}>Full Name:</span>
                        <br />
                        <span
                          style={{
                            backgroundColor: '#f8ff90',
                            padding: '2px 10px',
                            fontSize: '16px',
                          }}
                        >
                          {selectedRecord.f_name} {selectedRecord.m_name}{' '}
                          {selectedRecord.l_name}
                        </span>
                      </div>

                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Qualification:</span>
                        <br /> {selectedRecord.qualification || '-'}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Professional Category:</span>
                        <br /> {selectedRecord.jobCategoryData.category_name}
                      </div>
                      <div className="col-md-8 py-1">
                        <span style={labelCss}>Current Address:</span>
                        <br /> {selectedRecord.current_address}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Pincode:</span>
                        <br /> {selectedRecord.pincode}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>State:</span>
                        <br /> {selectedRecord.stateData.stateenname}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>District:</span>
                        <br /> {selectedRecord.districtData.districtenname}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Taluka:</span>
                        <br /> {selectedRecord.talukaData.talukaenname}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Date of Birth:</span>
                        <br /> {selectedRecord.date_of_birth}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Blood Group:</span>
                        <br /> {selectedRecord.blood_group}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Mobile No:</span>
                        <br /> {selectedRecord.mobile}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Email Id:</span>
                        <br /> {selectedRecord.email}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Business / Service Name:</span>
                        <br /> {selectedRecord.business_service_name}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Year Of Boarding From:</span>
                        <br /> {selectedRecord.from_year_of_boarding}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Year Of Boarding To:</span>
                        <br /> {selectedRecord.to_year_of_boarding}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Reference Name:</span>
                        <br /> {selectedRecord.reference_fname}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Reference Contact:</span>
                        <br /> {selectedRecord.reference_other_contact_details}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Achievements:</span>
                        <br /> {selectedRecord.achievements}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Suggestion:</span>
                        <br /> {selectedRecord.suggestion_comment}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default AlumniApprovedList
